import React, { useContext } from 'react';
import DesktopDevPageDisplaySide300x250 from '@wix/da-ads/pkg/adunits/DesktopDevPageDisplaySide300x250';
import DesktopDevPageSideVideoSide from '@wix/da-ads/pkg/adunits/DesktopDevPageSideVideoSide';
import MobileDevPageVideoStage from '@wix/da-ads/pkg/adunits/MobileDevPageVideoStage';
import MobileAdhesion from '@wix/da-ads/pkg/adunits/MobileAdhesion';
import ErrorBoundary from '../../../../ErrorBoundary';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import s from './Ad.scss';
var Ad = function (_a) {
    var block = _a.block;
    var isMobile = useContext(MobileContext);
    // TODO adhesion should probably live somewhere else, but this is fine for POC
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: s['root'] },
            React.createElement(ErrorBoundary, { debugComponent: "SidebarAd" },
                !isMobile && block.contentType === 'ad_top' && (React.createElement("div", { className: s['video'] },
                    React.createElement(DesktopDevPageSideVideoSide, null))),
                !isMobile && block.contentType === 'ad_middle' && (React.createElement("div", { className: s['display'] },
                    React.createElement(DesktopDevPageDisplaySide300x250, null))),
                isMobile && block.contentType === 'ad_top' && (React.createElement("div", { className: s['video'] },
                    React.createElement(MobileDevPageVideoStage, null))))),
        isMobile && block.contentType === 'ad_middle' && React.createElement(MobileAdhesion, null)));
};
Ad.displayName = 'Ad';
export default Ad;
//# sourceMappingURL=Ad.js.map